import React, { useEffect, useState } from 'react';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import BASE_URL from '../config';

const TourList = () => {
  const [tours, setTours] = useState([]);
  const [error, setError] = useState(false);
  const [favorites, setFavorites] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('all');


  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/api/tour/search/criteria?sort=popular&limit=10`)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        if (data.data && data.data.length > 0) setTours(data.data);
        else setError(true);
      })
      .catch(() => setError(true));
  }, []);

  const handleToggleFavorite = (id) => {
    setFavorites((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleCategoryClick = (category) => setSelectedCategory(category);


  const defaultTours = Array.from({ length: 7 }, (_, i) => ({
    ID: i,
    Name: `Sample Tour ${i + 1}`,
    NumberOfDays: "0",
    NumberOfNights: "0",
    TourMajorAttractions: [{ Name: "Sample Attraction" }],
    TourPlaces: [{ City: "Sample City", Country: "Sample Country" }],
    Price: "NA",
    Image: ''
  }));

  const displayedTours = error || tours.length === 0 ? defaultTours : tours;

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % displayedTours.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + displayedTours.length) % displayedTours.length);
  };

  return (
    <div className="container mb-5">
      <div className="d-flex justify-content-between align-items-center">
        <h3 style={{ color: "#321E5D", fontWeight: "800"}}>
          Trending <span style={{ color: "#680099"}}>Tours</span>
        </h3>
      </div>

      <div style={{marginBottom:'10px'}}>All destinations at one place</div>

      <div style={{ width: '100%',display: 'flex', justifyContent: 'space-between' ,flexDirection:'row'}}>
          <div className="d-flex gap-2 mb-3 overflow-y-auto">
          {['all', 'honeymoon', 'adventure', 'cultural', 'luxury'].map(category => (
            <button key={category} className="rounded-pill ps-3 pe-3 pt-1 pb-2" 
              style={{width:'120px',fontWeight:'700', border: "1px solid rgba(84, 28, 156, 1)", backgroundColor: selectedCategory === category ? '#541c9c' : 'white', color: selectedCategory === category ? 'white' : 'black'}}
              onClick={() => handleCategoryClick(category)}>
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
          </div>

        <div className="d-flex gap-2">
          <div className="rounded-circle d-flex justify-content-center align-items-center bg-white" 
            style={{ width: '40px', height: '40px', cursor: 'pointer', transition: 'transform 0.2s' }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            onClick={prevSlide}>
            <MdArrowBackIos size={24} />
          </div>
          <div className="rounded-circle d-flex justify-content-center align-items-center bg-white" 
            style={{ width: '40px', height: '40px', cursor: 'pointer', transition: 'transform 0.2s' }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            onClick={nextSlide}>
            <MdArrowForwardIos size={24} />
          </div>
        </div>

      </div>

      



      <div className="d-flex flex-column flex-md-row justify-content-center overflow-hidden w-100 px-3 pt-3 pb-3"> 
        {Array.from({ length: 3 }).map((_, i) => {
          const index = (currentIndex + i) % displayedTours.length;
          const tour = displayedTours[index];
          return (
            <div
                key={index}
                className="card border-2 rounded-4 flex-grow-1 transition-all"
                style={{
                  minWidth: "20%",
                  margin: "10px 90px 10px 10px",
                  border: "2px solid rgba(139, 9, 219, 1)", // Permanent purple border
                  transition: "all 0.3s ease-in-out", // Smooth effect
                  boxShadow: "none", // No default shadow
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0px 0px 20px 8px rgba(139, 9, 219, 0.6)"; // Bright glow
                  e.currentTarget.style.transform = "scale(1.05)"; // Slightly enlarge
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none"; // Remove glow
                  e.currentTarget.style.transform = "scale(1)"; // Reset size
                }}
              >
              <div className="position-relative w-100 rounded-4" 
                style={{ height: '230px', backgroundImage: `url(${tour.Image || 'https://via.placeholder.com/280x160/CCCCCC/808080?text=No+Image'})`, backgroundSize: 'cover', backgroundPosition: 'center',                  backgroundColor: tour.Image ? 'transparent' : '#CCCCCC'  
              }}>
                <div className="badge position-absolute top-0 start-0 m-2 p-1 px-2 rounded-pill bg-danger text-white" style={{ fontSize: '12px' }}>
                  {tour.TourCategory || "NA"}
                </div>
                <div className="position-absolute top-0 end-0 p-2 bg-white rounded-circle" style={{ cursor: 'pointer', margin: '10px',marginRight:'40px' }} onClick={() => handleToggleFavorite(tour.ID)}>
                  {favorites[tour.ID] ? <AiFillHeart size={20} className='text-danger' /> : <AiOutlineHeart size={20} />}
                </div>
              </div>
              <div className="card-body d-flex flex-column">
                {/* Name and Duration in One Line */}
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="fw-bold m-0">{tour.Name || "N/A"}</h6>
                  <span className="text-secondary small">{tour.NumberOfDays}D / {tour.NumberOfNights}N</span>
                </div>

                {/* Highlights and Locations without extra gap */}
                <p className="small text-secondary mt-3 mb-0">
                  Highlights:{tour.TourMajorAttractions?.map(attraction => attraction.Name).join(", ") || "N/A"}
                </p>
                <p className="small text-secondary mb-2">
                  {tour.TourPlaces?.map(place => `${place.City}, ${place.Country}`).join(", ") || "N/A"}
                </p>

                {/* Price and Book Now Button */}
                <div className="d-flex justify-content-between align-items-center mt-auto">
                  <h6 className="fw-bold mb-0">₹{tour.Price || "N/A"} /person</h6>
                  <button className="btn rounded-pill px-3" style={{ backgroundColor: "#936fe0", color: "white",fontWeight:'700' }} onClick={() => navigate(`/book/${tour.ID}`)}>
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-4">
        <button className="btn btn-lg rounded-pill py-2" style={{width:'300px', backgroundColor: "rgba(84, 28, 156, 1)", color: "white",weight:'600' }} onClick={() => navigate('/tours')}>
          Explore All Tours
        </button>
      </div>

    </div>
  );
};

export default TourList;